module.exports = __webpack_public_path__ + "static/media/miami-13.42c450a6.jpg";